import { hasWindow } from "@omni/utils/dom.utils";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import * as CustomerModule from "@/redux/modules/api/data/customer/customer.module";
import * as OrderDetailsSelectors from "@/redux/modules/api/data/orderDetail/orderDetail.selectors";
import { broadcastMessage } from "@/redux/modules/value/messages/messages.utils";
import { EcornerService } from "@/services/eCorner.service";

import LogoutButton from "./logoutButton.component";

type Props = {
    text: string;
    message: string;
    target: string;
};

const LogoutButtonContainer = ({ text, message, target }: Props) => {
    const dispatch = useThunkDispatch();
    const order = useSelector(OrderDetailsSelectors.getOrder);

    const customer = order?.customer;

    const onLogout = () => {
        dispatch(CustomerModule.logout()).then((action) => {
            if (action.type === CustomerModule.APIStatus.SUCCESS) {
                broadcastMessage({
                    id: target,
                    text: message,
                    status: "success",
                    dismissible: false
                });

                const element = hasWindow()
                    ? document?.querySelector(`div[data-messageid="${target}"]`)
                    : undefined;

                if (element) {
                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                        inline: "center"
                    });
                }
            }
        });
    };

    return (
        <>
            {!EcornerService.isEcornerEnvironment() &&
                customer &&
                !customer.guest && (
                    <LogoutButton
                        text={text}
                        logout={onLogout}
                    />
                )}
        </>
    );
};

export { LogoutButtonContainer };
